export default {"src":"/_next/static/media/community.1b003141.svg","height":150,"width":150,"blurWidth":0,"blurHeight":0};